import { render, staticRenderFns } from "./HealthQuestionnaire2CN.vue?vue&type=template&id=f3556732"
import script from "./HealthQuestionnaire2CN.vue?vue&type=script&lang=js"
export * from "./HealthQuestionnaire2CN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports